import { RootState } from '@store/store'
export const getArticleLoading = (state: RootState) => state.articles.loading
